<gameday-direct-header
  [loggedIn]="isAuthorized | async"
  [username]="username | async"
></gameday-direct-header>
<div
  *ngIf="isLoading | async"
  class="c-loader" [class.hidden]="!(isAuthorized | async)"
>
</div>
<router-outlet></router-outlet>
